import { useRef, useState } from 'react';

import { AddressStreamerNorlys } from '~src/components/AddressStreamer';
import { BackButton } from '~src/components/BackButton';
import { CollapsiblePanelNorlys } from '~src/components/CollapsiblePanel';
import { CalculatorHeaderNorlys } from '~src/components/Header/CalculatorHeader/norlys';
import { SendOfferModalNorlys } from '~src/components/Modal/sendOffer';
import { SavingsWidgetNorlys } from '~src/components/SavingsWidget';
import { CALCULATOR_THANK_YOU_PAGE_NORLYS } from '~src/constants';
import { usePublicCalculatorContext } from '~src/context/PublicCalculatorContext';
import { useScrollElementToTop } from '~src/hooks/useScroll';
import { isResidenceFilled } from '~src/util';

import { useCalculatorNavigation } from '~src/hooks/useNavigation';
import { useInformationPageStepsNorlys, useProceedProperties, useUpdateStage } from '~src/hooks/NorlysInformationPage';
import { InformationPageDesktopBase } from './InformationPageDesktopBase';

export const InformationPageDesktopNorlys = () => {
  const scrollReference = useRef<HTMLDivElement>(null);

  const [showModal, setShowModal] = useState(false);

  const { visitedStageMap, residence, openStageMap, setOpenStageMap, address, takeover } = usePublicCalculatorContext();

  useScrollElementToTop(scrollReference, openStageMap);

  const steps = useInformationPageStepsNorlys(false);
  const totalSteps = steps.length;

  const updateStage = useUpdateStage(totalSteps);

  const areAllStepsDone = Object.keys(visitedStageMap).length >= totalSteps;

  const isEverythingFilled = isResidenceFilled(residence);

  const navigate = useCalculatorNavigation('information');

  const getProceedProperties = useProceedProperties(setShowModal, updateStage, takeover);

  return (
    <>
      <InformationPageDesktopBase
        {...{
          sendButton: {
            type: areAllStepsDone ? 'callToAction' : 'default',
            disabled: !isEverythingFilled,
          },
          header: <CalculatorHeaderNorlys />,
          SavingsWidget: SavingsWidgetNorlys,
          savingsWidgetStyle: {
            backgroundColor: 'transparent',
            maxHeight: undefined,
            height: 'fit-content',
            minWidth: '300px',
            borderRadius: '8px',
          },
          SendOfferModal: SendOfferModalNorlys,
          redirectURL: CALCULATOR_THANK_YOU_PAGE_NORLYS,
          showModal,
          setShowModal,
        }}
      >
        <div style={{ width: '100%', marginBottom: '8px', display: 'flex', alignItems: 'center' }}>
          <BackButton style={{ marginLeft: '16px' }} onClick={() => navigate('address')} label='' />

          <AddressStreamerNorlys
            style={{ margin: '16px 32px 16px 8px' }}
            {...{
              address,
              residence,
              position: 'inline',
            }}
          />
        </div>
        {steps.map(({ title, content, completed }, index) => {
          const stage = index + 1;

          const { onProceed, proceedText } = getProceedProperties(index, steps.length - 1, stage);

          return (
            <CollapsiblePanelNorlys
              key={`panel-${stage}`}
              {...{
                open: openStageMap[stage],
                onClick: () => setOpenStageMap?.(map => ({ ...map, [stage]: map[stage] ? false : true })),
                done: visitedStageMap[stage],
                onProceed,
                proceedText: proceedText ?? 'Gå videre',
                proceedDisabled: !completed,
                ref: index > 0 && openStageMap[stage] ? scrollReference : null,
                title,
              }}
            >
              {content}
            </CollapsiblePanelNorlys>
          );
        })}
      </InformationPageDesktopBase>
    </>
  );
};
